// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { z } from 'zod';

export const fulfillmentStatusSchema = z.enum([
  'UNFULFILLED',
  'PARTIALLY_FULFILLED',
  'FULFILLED',
  'OVER_FULFILLED',
]);

export type FulfillmentStatus = z.infer<typeof fulfillmentStatusSchema>;

export const FULFILLMENT_STATUSES = fulfillmentStatusSchema.options;

/**
 * Human-readable labels for frontend fulfillment status values
 */
export const FULFILLMENT_STATUS_LABELS: Record<FulfillmentStatus, string> = {
  UNFULFILLED: 'Not filled',
  PARTIALLY_FULFILLED: 'Underfilled',
  FULFILLED: 'Filled',
  OVER_FULFILLED: 'Overfilled',
};

/**
 * Color configuration for fulfillment status badges
 */
export const FULFILLMENT_STATUS_COLORS: Record<
  FulfillmentStatus,
  {
    color?: 'error' | 'warning' | 'success';
    customColor?: string;
  }
> = {
  UNFULFILLED: {
    color: 'error',
  },
  PARTIALLY_FULFILLED: {
    color: 'warning',
  },
  FULFILLED: {
    color: 'success',
  },
  OVER_FULFILLED: {
    customColor: '#36013F',
  },
};
